import AuthGuard from './auth-guard'
import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/Home'
import signin from '@/views/User/signInWithPhoneAuth'
import userProfile from "@/views/User/userProfile";
import checkPhoneAuth from "@/views/User/checkPhoneAuth";
import fulfillment from "@/views/fulfillment/fulfillment"
import expressCheckIn from "@/views/fulfillment/expressCheckIn.vue";
import fulfillments from "@/views/fulfillment/fulfillments.vue"
// twilio phonenumbers
import getNewPhoneNumber from "@/views/phoneNumbers/getNewPhoneNumber";
// services
import postedService from "@/views/services/postedService";

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/signin',
      name: 'signin',
      component: signin
    },
    {
      path: '/fulfillments',
      name: 'fulfillments',
      component: fulfillments
    },
    {
      path: '/fulfillment/:fulfillmentId',
      name: 'fulfillment',
      component: fulfillment,
      props: true
    },
    {
      path: '/postedServices/:serviceProviderId/:linkId',
      name: 'postedService',
      component: postedService,
      props: true
    },
    {
      path: '/expressCheckIn/:serviceProviderId/:fulfillmentId',
      name: 'expressCheckIn',
      component: expressCheckIn,
      props: true
    },
    {
      path: '/checkSmsAuth/:publicListingId/:routeTo/:routeType/:orderId',
      name: 'checkPhoneAuth',
      component: checkPhoneAuth,
      props: true
    },
    {
      path: '/editProfile',
      name: 'userProfile',
      component: userProfile,
      beforeEnter: AuthGuard
    },
    {
      path: '/getNewPhoneNumber',
      name: 'Get Phone Number',
      component: getNewPhoneNumber
    },
  ],
  mode: 'history'
})
